import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  DataExportForAllUsersAction,
  DataExportForAllUsersFulfilledAction,
  DataExportForNetworkAction,
  DataExportForNetworkFulfilledAction,
  DataExportForUserAction,
  DataExportForUserFulfilledAction,
} from '../../domains/dataExport/actions.types';

import type { DataExports } from './types';

export type DataExportAction = DataExportForNetworkAction | DataExportForUserAction | DataExportForAllUsersAction;

const initialState: DataExports = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const stateWithFulfilledSearch = (
  state: DataExports,
  payload:
    | DataExportForNetworkFulfilledAction['payload']
    | DataExportForUserFulfilledAction['payload']
    | DataExportForAllUsersFulfilledAction['payload']
): DataExports => {
  const { id, ...payloadWithoutId } = payload;

  const results = {
    [id]: {
      id,
      ...payloadWithoutId,
    },
  };

  return moveToFulfilled(state, results);
};

const reducer: Reducer<DataExports, DataExportAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'DATA_EXPORT_FOR_NETWORK.LOAD_PENDING': {
      return moveToPending(state, [action.payload.id]);
    }
    case 'DATA_EXPORT_FOR_NETWORK.LOAD_FULFILLED': {
      return stateWithFulfilledSearch(state, action.payload);
    }
    case 'DATA_EXPORT_FOR_NETWORK.LOAD_REJECTED': {
      return moveToRejected(state, [action.payload.id], action.payload.error);
    }
    case 'DATA_EXPORT_FOR_USER.LOAD_PENDING': {
      return moveToPending(state, [action.payload.id]);
    }
    case 'DATA_EXPORT_FOR_USER.LOAD_FULFILLED': {
      return stateWithFulfilledSearch(state, action.payload);
    }
    case 'DATA_EXPORT_FOR_USER.LOAD_REJECTED': {
      return moveToRejected(state, [action.payload.id], action.payload.error);
    }
    case 'DATA_EXPORT_FOR_ALL_USERS.LOAD_PENDING': {
      return moveToPending(state, [action.payload.id]);
    }
    case 'DATA_EXPORT_FOR_ALL_USERS.LOAD_FULFILLED': {
      return stateWithFulfilledSearch(state, action.payload);
    }
    case 'DATA_EXPORT_FOR_ALL_USERS.LOAD_REJECTED': {
      return moveToRejected(state, [action.payload.id], action.payload.error);
    }
    default:
      return state;
  }
};

export default reducer;
